export default __webpack_public_path__ + "static/media/juja-han-HU-uL54pfQI-unsplash.4fbc26d0.jpg";